<template>
    <div>
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario" @submit.prevent="!visualizar && insereOuAtualiza()" novalidate>
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="cliente.id">

                <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==1">
                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="person-badge"></b-icon> Dados do usuário</legend>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label for="inputNome" class="ec-obrigatorio">Nome completo</label>
                                <input :readonly="visualizar" type="text" autocomplete="name" class="form-control" :class="{ 'is-invalid': errors.nome }" id="inputNome" name="inputNome" placeholder="Nome e sobrenome" v-model="cliente.nome">
                                <div class="invalid-feedback" v-if="errors.nome">{{ errors.nome[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCPF" class="ec-obrigatorio">CPF</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['###.###.###-##']" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.cpf }" id="inputCPF" name="inputCPF" placeholder="000.000.000-00" v-model="doc"/>
                                <div class="invalid-feedback" v-if="errors.cpf">{{ errors.cpf[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="tipoCadastroPessoa" class="ec-obrigatorio">Tipo de cadastro</label>
                                <select :disabled="edit || visualizar" id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="custom-select" v-model="tipoCadastro">
                                    <option value="1">CPF</option>
                                </select>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="perfil_usuario" class="ec-obrigatorio">Perfil de usuário</label>
                                <select :disabled="visualizar" id="perfil_usuario" name="perfil_usuario" class="custom-select" :class="{ 'is-invalid': errors.perfil_usuario }" v-model="cliente.perfil_usuario">
                                    <option value="0">Selecione o perfil</option>
                                    <option v-for="perfil in perfisDisponiveis()" :key="perfil.id" :value="perfil.id">{{ perfil.descricao }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors.perfil_usuario">{{ errors.perfil_usuario[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3 ec-campo-switch">
                                <label for="cadastroAtivo">Situação</label>
                                <b-form-checkbox id="cadastroAtivo" v-model="cliente.ativo" name="cadastroAtivo" :value="'Ativo'" :unchecked-value="'Inativo'" :disabled="visualizar || urlSistema=='Account/MyAccount'" :switch="true">
                                    {{ cliente.ativo=='Ativo' ? 'Ativo' : 'Inativo' }}
                                </b-form-checkbox>
                            </div>
                            <div class="form-group col-lg-6 ec-campo-switch">
                                <label :for="'tarefa_automatica'+cliente.id">Tarefas automáticas</label>
                                <b-form-checkbox :id="'tarefa_automatica'+cliente.id" v-model="cliente.tarefa_automatica" name="tarefa_automatica" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Usar este usuário nas tarefas automáticas
                                </b-form-checkbox>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="key"></b-icon> Acesso</legend>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="inputEmail" class="ec-obrigatorio">E-mail (login)</label>
                                <input :readonly="visualizar" type="email" autocomplete="username" class="form-control" :class="{ 'is-invalid': errors.email }" id="inputEmail" name="inputEmail" placeholder="nome@instituicao.com.br" v-model="cliente.email">
                                <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="password" :class="{ 'ec-obrigatorio': !edit }">Senha</label>
                                <input :readonly="visualizar" type="password" autocomplete="new-password" class="form-control" :class="{ 'is-invalid': errors.password }" id="password" name="password" :placeholder="edit ? 'Deixe em branco para manter a atual' : 'Mínimo de 8 caracteres'" v-model="cliente.password">
                                <div class="invalid-feedback" v-if="errors.password">{{ errors.password[0] }}</div>
                                <small class="form-text" v-if="!visualizar">Use ao menos 8 caracteres, com letras maiúsculas e minúsculas, números e símbolos.</small>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="password_confirmation" :class="{ 'ec-obrigatorio': !edit }">Confirmação de senha</label>
                                <input :readonly="visualizar" type="password" autocomplete="new-password" class="form-control" :class="{ 'is-invalid': errors.password_confirmation || senhasDiferentes }" id="password_confirmation" name="password_confirmation" placeholder="Repita a senha" v-model="cliente.password_confirmation">
                                <div class="invalid-feedback" v-if="errors.password_confirmation">{{ errors.password_confirmation[0] }}</div>
                                <div class="invalid-feedback" v-else-if="senhasDiferentes">As senhas não conferem.</div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="telephone"></b-icon> Contato e notificações</legend>
                        <div class="form-row">
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputFone" class="ec-obrigatorio">Telefone</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" :class="{ 'is-invalid': errors.telefone }" id="inputFone" name="inputFone" placeholder="(00)0000-0000" v-model="cliente.telefone"/>
                                <div class="invalid-feedback" v-if="errors.telefone">{{ errors.telefone[0] }}</div>
                            </div>
                            <div class="form-group col-sm-6 col-lg-3">
                                <label for="inputCelular">Celular</label>
                                <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" id="inputCelular" name="inputCelular" placeholder="(00)00000-0000" v-model="cliente.celular"/>
                            </div>
                            <div class="form-group col-lg-6 ec-campo-switch">
                                <label :for="'comunica_login'+cliente.id">Notificações</label>
                                <b-form-checkbox :id="'comunica_login'+cliente.id" v-model="cliente.comunica_login" name="comunica_login" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">
                                    Receber e-mail a cada novo login
                                </b-form-checkbox>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao" v-if="showUnities">
                        <legend><b-icon icon="building"></b-icon> Unidades vinculadas</legend>
                        <p class="ec-form-secao__descricao">Módulos que este usuário pode acessar em cada unidade. Módulos não licenciados para a unidade ficam bloqueados.</p>
                        <div class="table-responsive mb-3">
                            <table v-ec-datatable class="table table-sm table-hover ec-tabela mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-left">Unidade</th>
                                        <th class="text-center">Código (ERP)</th>
                                        <th v-for="modulo in modulosUnidade" :key="modulo.campo" class="text-center ec-dt-sem-ordem">{{ modulo.titulo }}</th>
                                        <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!usuario_unidades || usuario_unidades.length==0">
                                        <td :colspan="modulosUnidade.length+3" class="ec-tabela__estado">
                                            <b-icon icon="inbox" font-scale="2"></b-icon>
                                            <p>Nenhuma unidade vinculada.</p>
                                        </td>
                                    </tr>
                                    <tr v-for="unidade in usuario_unidades" :key="unidade.id">
                                        <td class="text-left" data-label="Unidade">{{ unidade.nomecompleto }}</td>
                                        <td class="text-center" data-label="Código (ERP)">{{ unidade.codigounidade }}</td>
                                        <td v-for="modulo in modulosUnidade" :key="modulo.campo" class="text-center" :data-label="modulo.titulo">
                                            <b-form-checkbox class="d-inline-block" :id="modulo.campo+unidade.id" v-model="unidade[modulo.campo]" :name="modulo.campo" :value="1" :unchecked-value="0" :disabled="moduloBloqueado(unidade, modulo)" :switch="true" :title="unidade['op_'+modulo.campo]==1 ? '' : 'Módulo não licenciado para esta unidade'">
                                                <span class="sr-only">{{ modulo.titulo }} em {{ unidade.nomecompleto }}</span>
                                            </b-form-checkbox>
                                        </td>
                                        <td class="ec-tabela__col-acoes" data-label="Ações">
                                            <div class="ec-acoes">
                                                <button class="btn btn-outline-danger btn-sm" @click.prevent="desvincularUnidade(unidade)" :disabled="visualizar || urlSistema=='Account/MyAccount'" :aria-label="'Desvincular ' + unidade.nomecompleto"><b-icon icon="x-lg" aria-hidden="true"></b-icon> Desvincular</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao" v-if="showUnities && urlSistema=='Users/User'">
                        <legend><b-icon icon="plus-circle"></b-icon> Unidades disponíveis</legend>
                        <p class="ec-form-secao__descricao">Ajuste os módulos e clique em <b>Vincular</b> para dar acesso à unidade.</p>
                        <div class="table-responsive mb-3">
                            <table v-ec-datatable class="table table-sm table-hover ec-tabela mb-0">
                                <thead class="ec-thead">
                                    <tr>
                                        <th class="text-left">Unidade</th>
                                        <th class="text-center">Código (ERP)</th>
                                        <th v-for="modulo in modulosUnidade" :key="modulo.campo" class="text-center ec-dt-sem-ordem">{{ modulo.titulo }}</th>
                                        <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!todas_unidades || todas_unidades.length==0">
                                        <td :colspan="modulosUnidade.length+3" class="ec-tabela__estado">
                                            <b-icon icon="inbox" font-scale="2"></b-icon>
                                            <p>Todas as unidades já estão vinculadas.</p>
                                        </td>
                                    </tr>
                                    <tr v-for="unidade in todas_unidades" :key="unidade.id">
                                        <td class="text-left" data-label="Unidade">{{ unidade.nomecompleto }}</td>
                                        <td class="text-center" data-label="Código (ERP)">{{ unidade.codigounidade }}</td>
                                        <td v-for="modulo in modulosUnidade" :key="modulo.campo" class="text-center" :data-label="modulo.titulo">
                                            <b-form-checkbox class="d-inline-block" :id="modulo.campo+unidade.id" v-model="unidade[modulo.campo]" :name="modulo.campo" :value="1" :unchecked-value="0" :disabled="moduloBloqueado(unidade, modulo)" :switch="true" :title="unidade['op_'+modulo.campo]==1 ? '' : 'Módulo não licenciado para esta unidade'">
                                                <span class="sr-only">{{ modulo.titulo }} em {{ unidade.nomecompleto }}</span>
                                            </b-form-checkbox>
                                        </td>
                                        <td class="ec-tabela__col-acoes" data-label="Ações">
                                            <div class="ec-acoes">
                                                <button class="btn btn-primary btn-sm" @click.prevent="vincularUnidade(unidade)" :disabled="visualizar || urlSistema=='Account/MyAccount'" :aria-label="'Vincular ' + unidade.nomecompleto"><b-icon icon="plus-lg" aria-hidden="true"></b-icon> Vincular</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </fieldset>
                </template>

                <div class="ec-form-acoes">
                    <span class="ec-form-legenda" v-if="!visualizar">Campos obrigatórios</span>
                    <a :href="'/'+urlSistema" class="btn btn-outline-primary">{{ visualizar ? 'Voltar' : 'Cancelar' }}</a>
                    <button v-if="!visualizar" type="submit" class="btn btn-primary"><b-icon icon="check2"></b-icon> Salvar</button>
                </div>
            </form>
        </div>
        <modal-component titulo="Mensagem do Sistema" label-btn-fechar="OK" id="MensagemSistema" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
            </template>
            <template v-slot:conteudo>
                <div class="ec-resumo">
                    <p class="ec-resumo__titulo">
                        <slot name="titulo">
                            Usuário
                        </slot>
                    </p>
                    <div v-if="transacaoStatus" class="alert alert-success ec-resumo__alerta" role="alert">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                        <span v-if="edit">Atualizado com sucesso!</span>
                        <span v-else>Cadastrado com sucesso!</span>
                    </div>
                    <dl class="ec-resumo__ficha">
                        <dt>ID</dt>
                        <dd>{{ cliente.id }}</dd>
                        <dt>Nome</dt>
                        <dd>{{ cliente.nome || '—' }}</dd>
                        <dt>CPF</dt>
                        <dd>{{ cliente.cpf || '—' }}</dd>
                    </dl>
                </div>
            </template>
        </modal-component>
        <loading id="SalvandoUsuario" titulo="Salvando Usuários, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>


export default{

    computed:{
        senhasDiferentes(){
            return !!(this.cliente.password && this.cliente.password_confirmation && this.cliente.password!==this.cliente.password_confirmation)
        },
    },
    methods:{
        perfisDisponiveis(){
            return (this.perfil_usuario || []).filter(perfil => this.usuarioAutenticado.perfil_usuario<=perfil.id)
        },
        // módulo fica bloqueado no modo visualização, em "Minha conta" ou quando não é licenciado para a unidade
        moduloBloqueado(unidade, modulo){
            return this.visualizar || this.urlSistema=='Account/MyAccount' || unidade['op_'+modulo.campo]!=1
        },
        dissmiss(id){
            this.$bvModal.hide(id);
        },
        novo(id){
            this.user = {}
            this.modoeditar = false
            this.modoexcluir = false
            this.modonovo = true
            this.texto_modal = "Novo"
            this.user.id=id
            // console.log(this.user)
        },
        editar(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = true
            this.modoexcluir = false
            this.modonovo = false
            this.texto_modal = "Editar"
            // console.log(this.user)
            // console.log(this.user)
        },
        excluir(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = false
            this.modoexcluir = true
            this.modonovo = false
            this.texto_modal = "Excluir"
            // console.log(this.user)
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        removerPorId: function (id) {
            var _vm = this; //Adicionando a instância à uma variável, para que possa ser acessada dentro do forEach`
            this.users.forEach(function(el, index) {
                if(el.id === id)
                    _vm.users.splice(index, 1);
            })
        },
        insereOuAtualiza(){
            if(!this.edit){
                this.inserirUsuario();
                //console.log('insere')
            }else{
                this.atualizaUsuario();
                //console.log('atualiza')
            }
        },
        inserirUsuario(){
            // if(this.modonovo){
                let url='/api/v1/'+this.urlSistema;
                $('#SalvandoUsuario').modal('show');
                //console.log(this.cliente);
                let unities_user = ""
                let unities_unbind="";
                for(let i=0;i<this.usuario_unidades.length;i++){
                    if(i<this.usuario_unidades.length-1){
                        unities_user = unities_user + this.usuario_unidades[i].id+","
                    }else{
                        unities_user = unities_user + this.usuario_unidades[i].id
                    }
                }

                for(let i=0;i<this.todas_unidades.length;i++){
                    if(i<this.todas_unidades.length-1){
                        unities_unbind = unities_unbind + this.todas_unidades[i].id+","
                    }else{
                        unities_unbind = unities_unbind + this.todas_unidades[i].id
                    }
                }
                let formData = new FormData();
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('nome', (this.cliente.nome?this.cliente.nome:''))
                formData.append('cpf', (this.cliente.cpf?this.cliente.cpf:''))
                formData.append('perfil_usuario', (this.cliente.perfil_usuario?this.cliente.perfil_usuario:0))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('email',(this.cliente.email?this.cliente.email:''))
                formData.append('password',(this.cliente.password?this.cliente.password:''))
                formData.append('password_confirmation',(this.cliente.password_confirmation?this.cliente.password_confirmation:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('comunica_login',(this.cliente.comunica_login==1?'1':'0'))
                formData.append('tarefa_automatica', (this.cliente.tarefa_automatica?this.cliente.tarefa_automatica:'0'))
                formData.append('unidades_usuario',JSON.stringify(this.usuario_unidades))
                formData.append('unidades_desvincular',JSON.stringify(this.todas_unidades))
                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }

                axios.post(url,formData,configuracao)
                    .then(response => {
                        
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.errors={};
                        this.cliente.CadastroTipo=1
                        $('#SalvandoUsuario').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                        $('#SalvandoUsuario').modal('hide');
                    })
            // }
        },
        atualizaUsuario(){
            // if(this.modonovo){
                $('#SalvandoUsuario').modal('show');
                let url='/api/v1/'+this.urlSistema+'/'+this.cliente.id;
                console.log(url);
                let unities_user = ""
                let unities_unbind="";
                for(let i=0;i<this.usuario_unidades.length;i++){
                    if(i<this.usuario_unidades.length-1){
                        unities_user = unities_user + this.usuario_unidades[i].id+","
                    }else{
                        unities_user = unities_user + this.usuario_unidades[i].id
                    }
                }

                for(let i=0;i<this.todas_unidades.length;i++){
                    if(i<this.todas_unidades.length-1){
                        unities_unbind = unities_unbind + this.todas_unidades[i].id+","
                    }else{
                        unities_unbind = unities_unbind + this.todas_unidades[i].id
                    }
                }
                
                let formData = new FormData();
                formData.append('_method','patch');
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('nome', (this.cliente.nome?this.cliente.nome:''))
                formData.append('perfil_usuario', (this.cliente.perfil_usuario?this.cliente.perfil_usuario:0))
                formData.append('cpf', (this.cliente.cpf?this.cliente.cpf:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('email',(this.cliente.email?this.cliente.email:''))
                formData.append('password',(this.cliente.password?this.cliente.password:''))
                formData.append('password_confirmation',(this.cliente.password_confirmation?this.cliente.password_confirmation:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('comunica_login',(this.cliente.comunica_login==1?'1':'0'))
                formData.append('tarefa_automatica', (this.cliente.tarefa_automatica?this.cliente.tarefa_automatica:'0'))
                formData.append('unidades_usuario',JSON.stringify(this.usuario_unidades))
                formData.append('unidades_desvincular',JSON.stringify(this.todas_unidades))
                //console.log(JSON.stringify(this.todas_unidades));
                
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        console.log('User:',response.data.usuarioNovo)
                        this.errors={};
                        this.cliente.CadastroTipo=1
                        $('#SalvandoUsuario').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                        $('#SalvandoUsuario').modal('hide');
                    })
            // }
        },
        excluirUsuarioCliente(id){
            
            if(this.modoexcluir){
                var config = {
                method: 'delete',
                url: '/api/v1/'+this.urlSistema+'/'+id,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    debugger;
                    // console.log(response.data.usuario)
                    this.$bvModal.hide('modal-prevent-closing')
                    this.$nextTick(() => {
                        window.alert("Usuário de Cliente excluído com sucesso");
                    })
                    this.removerPorId(id)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        vincularUnidade(unidade){
            this.usuario_unidades.push(unidade);
            for(let i=0;i<this.unidades.length;i++){
                if(this.unidades[i].id==unidade.id){
                    this.unidades.splice(i,1);
                }
            }
            this.ordenarUnidades()
        },
        desvincularUnidade(unidade){
            
            this.unidades.push(unidade);
            //this.unidades.push(unidade);
            for(let i=0;i<this.usuario_unidades.length;i++){
                if(this.usuario_unidades[i].id==unidade.id){
                    this.usuario_unidades.splice(i,1);
                }
            }
            this.ordenarUnidades()
        },
        // mantém as duas listas em ordem alfabética após vincular/desvincular
        ordenarUnidades(){
            const porNome = (a, b) => String(a.nomecompleto || '').localeCompare(String(b.nomecompleto || ''), 'pt-BR')
            this.unidades.sort(porNome)
            this.usuario_unidades.sort(porNome)
        },
        
    },
    mounted(){
        // this.$root.atualizaCookie('token');
    },
    created(){
        if(this.pessoa){
            this.cliente = this.pessoa;
            //console.log(this.cliente)
            this.users = this.usuarios;
            this.doc=this.pessoa.cpf;
            this.cliente.CadastroTipo=1
            this.tipoCadastro=1
            this.usuario_unidades = this.unidades_usuario
            this.todas_unidades = this.unidades

            for(let j=0;j<this.usuario_unidades.length;j++){
                for(var i=0;i<this.todas_unidades.length;i++){
                // console.log()
                   // console.log(this.todas_unidades[i].codigounidade)
                    if(this.todas_unidades[i].id==this.usuario_unidades[j].id){
                        this.todas_unidades.splice(i,1);
                    }
                }
                
            }
            
            for(let i=0;i<this.todas_unidades.length;i++){
                this.todas_unidades[i].op_oferta_processo_seletivo = this.todas_unidades[i].oferta_processo_seletivo==1?true:false;
                this.todas_unidades[i].op_oferta_Inscricao_web = this.todas_unidades[i].oferta_Inscricao_web==1?true:false;
                this.todas_unidades[i].op_inscricao_web_aluno = this.todas_unidades[i].inscricao_web_aluno==1?true:false;
                this.todas_unidades[i].op_importar_parcela = this.todas_unidades[i].importar_parcela==1?true:false;
                this.todas_unidades[i].op_download_contrato = this.todas_unidades[i].download_contrato==1?true:false;
                
            }

            for(let i=0;i<this.usuario_unidades.length;i++){
                this.usuario_unidades[i].op_oferta_processo_seletivo = this.usuario_unidades[i].oferta_processo_seletivo==1?true:false;
                this.usuario_unidades[i].op_oferta_Inscricao_web = this.usuario_unidades[i].oferta_Inscricao_web==1?true:false;
                this.usuario_unidades[i].op_inscricao_web_aluno = this.usuario_unidades[i].inscricao_web_aluno==1?true:false;
                this.usuario_unidades[i].op_importar_parcela = this.usuario_unidades[i].importar_parcela==1?true:false;
                this.usuario_unidades[i].op_download_contrato = this.usuario_unidades[i].download_contrato==1?true:false;
                for(let a = 0; a< this.unity_user.length;a++){
                    if(this.unity_user[a].unity_id == this.usuario_unidades[i].id){
                        
                        this.usuario_unidades[i].oferta_processo_seletivo = this.unity_user[a].oferta_processo_seletivo
                        this.usuario_unidades[i].oferta_Inscricao_web = this.unity_user[a].oferta_Inscricao_web
                        this.usuario_unidades[i].inscricao_web_aluno = this.unity_user[a].inscricao_web_aluno
                        this.usuario_unidades[i].importar_parcela = this.unity_user[a].importar_parcela
                        this.usuario_unidades[i].download_contrato = this.unity_user[a].download_contrato
                    }
                }
            }

               
            
        }else{
            this.cliente.CadastroTipo=0;
            this.tipoCadastro=0;
            this.cliente.estado="0";
        }
    },
    props:{
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        showUnities:{
            type:Boolean,
            required:true
        },
        unidades_usuario:[],
        unity_user:[],
        unidades:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    watch: {
       // whenever question changes, this function will run
        texto_modal(newTexto, oldTtexto) {
            if (newTexto!=oldTtexto) {
                this.texto_modal=newTexto;
            }
        }
        ,tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.cliente.CadastroTipo=newTipoCadastro;
                this.tipoCadastro=newTipoCadastro;
                this.errors={};
            }
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.cliente.cpf=newdoc;
                this.doc=newdoc;
            }
        },
    },
    data(){
        return{
            modulosUnidade:[
                { campo:'oferta_processo_seletivo', titulo:'Processo seletivo' },
                { campo:'oferta_Inscricao_web',     titulo:'Inscrição web' },
                { campo:'inscricao_web_aluno',      titulo:'Inscrição do aluno' },
                { campo:'importar_parcela',         titulo:'Importação de parcela' },
                { campo:'download_contrato',        titulo:'Download de contrato' },
            ],
            teste:null,
            transacaoStatus:null,
            modonovo:false,
            modoeditar:false,
            modoexcluir:false,
            Novo:false,
            texto_modal:'',
            nameState: null,
            senhaState:null,
            emailState:null,
            submittedNames: [],
            tipoCadastro:null,
            doc:null,
            cliente:{
                id:null,
                nome:null,
                cpf:null,
                email:null,
                password:null,
                password_confirmation:null,
                telefone:null,
                celular:null,
                
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:1,
                
            },
            user:{
                id:null,
                name:null,
                email:null,
                senha:null,
            },
            users:[],
            errors:{},
            usuario_unidades:[], // guarda as unidades que o usuário está vinculado
            todas_unidades:[],
            perfil_usuario:[
                {
                    id:1,
                    descricao:'Administrador de Sistema'
                },
                {
                    id:2,
                    descricao:'Responsável de Empresa'
                },
                {
                    id:3,
                    descricao:'Usuário de Empresa'
                }
            ]
        }
    }
}
</script>

<style scoped>
    .custom-control, .custom-checkbox{
        font-size: 10px;
    }
    
    form{
        text-align: left!important;
    }

    /* resumo do registro no modal de confirmação (rótulo à esquerda, valor à direita; empilha no celular) */
    .ec-resumo {
        text-align: left;
    }

    .ec-resumo__titulo {
        margin: 0;
        padding: .75rem 1.25rem;
        border-bottom: 1px solid #e3e9ed;
        font-size: .78rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #1c4d5a;
    }

    .ec-resumo__alerta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;
        margin: 0;
        border-width: 0 0 1px;
        border-radius: 0;
        font-weight: 600;
    }

    .ec-resumo__ficha {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: .45rem 1rem;
        margin: 0;
        padding: 1rem 1.25rem;
    }

    .ec-resumo__ficha dt {
        align-self: center;
        font-size: .68rem;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
        color: #64767c;
    }

    .ec-resumo__ficha dd {
        margin: 0;
        font-weight: 600;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    @media (max-width: 575.98px) {
        .ec-resumo__ficha { grid-template-columns: 1fr; gap: .1rem; }
        .ec-resumo__ficha dd { margin-bottom: .5rem; }
        .ec-resumo__ficha dd:last-child { margin-bottom: 0; }
    }
</style>
